import React from 'react';
import PropTypes from 'prop-types';

import { TableRow, TableCell, Skeleton } from '@gbm/queen-ui-guidelines';

function PlaceholdersTable({ placeholderRows, placeholderCols, width }) {
  return (
    <>
      {[...Array(placeholderRows)].map((row, i) => (
        <TableRow key={`tr-${i}`}>
          {[...Array(placeholderCols)].map((col, j) => (
            <TableCell key={`tr-${i}-td-${j}`}>
              <Skeleton height={15} width={width} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

PlaceholdersTable.defaultProps = {
  placeholderRows: 3,
  placeholderCols: 3,
  width: '100%',
};

PlaceholdersTable.propTypes = {
  placeholderRows: PropTypes.number,
  placeholderCols: PropTypes.number,
  width: PropTypes.string,
};

export default PlaceholdersTable;
